export default __webpack_public_path__ + "static/media/resource-email-icon.9783009b.svg";